import AdditionalProductRequestParams from 'src/adminPanel/components/offsetting/orders/dialog/AdditionalProductRequestParams';
import Order from 'src/adminPanel/entities/offsetting/order/Order';
import { OrderRequestFilter } from 'src/adminPanel/entities/offsetting/order/OrderRequestFilter';
import { Address } from 'src/entities/basic-types/Address';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_ORDERS_BY_FILTER = 'FETCH_ORDERS_BY_FILTER';
export const REQUEST_ORDERS_BY_FILTER = 'REQUEST_ORDERS_BY_FILTER';
export const SUCCESS_ORDERS_BY_FILTER = 'SUCCESS_ORDERS_BY_FILTER';
export const FAILURE_ORDERS_BY_FILTER = 'FAILURE_ORDERS_BY_FILTER';

export const fetchOrdersByFilter = (filter?: OrderRequestFilter, pageable?: PageableQueryParams) =>
    action(FETCH_ORDERS_BY_FILTER, { filter, pageable });
export const requestOrdersByFilter = () => action(REQUEST_ORDERS_BY_FILTER_ID);
export const requestOrdersByFilterSuccess = (response: any) => action(SUCCESS_ORDERS_BY_FILTER_ID, { response });
export const requestOrdersByFilterFailure = (error: any) => action(FAILURE_ORDERS_BY_FILTER_ID, { error });

export const FETCH_ORDERS_BY_FILTER_ID = 'FETCH_ORDERS_BY_FILTER_ID';
export const REQUEST_ORDERS_BY_FILTER_ID = 'REQUEST_ORDERS_BY_FILTER_ID';
export const SUCCESS_ORDERS_BY_FILTER_ID = 'SUCCESS_ORDERS_BY_FILTER_ID';
export const FAILURE_ORDERS_BY_FILTER_ID = 'FAILURE_ORDERS_BY_FILTER_ID';

export const fetchOrdersByFilterId = (filterId: string, pageable?: PageableQueryParams) =>
    action(FETCH_ORDERS_BY_FILTER_ID, { filterId, pageable });
export const requestOrdersByFilterId = () => action(REQUEST_ORDERS_BY_FILTER_ID);
export const requestOrdersByFilterIdSuccess = (response: any) => action(SUCCESS_ORDERS_BY_FILTER_ID, { response });
export const requestOrdersByFilterIdFailure = (error: any) => action(FAILURE_ORDERS_BY_FILTER_ID, { error });

export const FETCH_ORDER_FILTER = 'FETCH_ORDER_FILTER';
export const REQUEST_ORDER_FILTER = 'REQUEST_ORDER_FILTER';
export const SUCCESS_ORDER_FILTER = 'SUCCESS_ORDER_FILTER';
export const FAILURE_ORDER_FILTER = 'FAILURE_ORDER_FILTER';

export const fetchOrderFilter = () => action(FETCH_ORDER_FILTER);
export const requestOrderFilter = () => action(REQUEST_ORDER_FILTER);
export const requestOrderFilterSuccess = (response: any) => action(SUCCESS_ORDER_FILTER, { response });
export const requestOrderFilterFailure = (error: any) => action(FAILURE_ORDER_FILTER, { error });

export const FETCH_ORDER_PRODUCT_DETAILS = 'FETCH_ORDER_PRODUCT_DETAILS';
export const REQUEST_ORDER_PRODUCT_DETAILS = 'REQUEST_ORDER_PRODUCT_DETAILS';
export const SUCCESS_ORDER_PRODUCT_DETAILS = 'SUCCESS_ORDER_PRODUCT_DETAILS';
export const FAILURE_ORDER_PRODUCT_DETAILS = 'FAILURE_ORDER_PRODUCT_DETAILS';

export const fetchOrderProductDetails = (publicId: string) => action(FETCH_ORDER_PRODUCT_DETAILS, { publicId });
export const requestOrderProductDetails = () => action(REQUEST_ORDER_PRODUCT_DETAILS);
export const requestOrderProductDetailsSuccess = (response: any) => action(SUCCESS_ORDER_PRODUCT_DETAILS, { response });
export const requestOrderProductDetailsFailure = (error: any) => action(FAILURE_ORDER_PRODUCT_DETAILS, { error });

export const CLEAR_ORDER_PRODUCT_DETAILS = 'CLEAR_ORDER_PRODUCT_DETAILS';
export const REQUEST_CLEAR_ORDER_PRODUCT_DETAILS = 'REQUEST_CLEAR_ORDER_PRODUCT_DETAILS';

export const clearOrderProductDetails = () => action(CLEAR_ORDER_PRODUCT_DETAILS);
export const requestClearOrderProductDetails = () => action(REQUEST_CLEAR_ORDER_PRODUCT_DETAILS);

export const UPDATE_BILLING_ADDRESS_ORDER = 'UPDATE_BILLING_ADDRESS_ORDER';
export const REQUEST_UPDATE_BILLING_ADDRESS_ORDER = 'REQUEST_UPDATE_BILLING_ADDRESS_ORDER';
export const SUCCESS_UPDATE_BILLING_ADDRESS_ORDER = 'SUCCESS_UPDATE_BILLING_ADDRESS_ORDER';
export const FAILURE_UPDATE_BILLING_ADDRESS_ORDER = 'FAILURE_UPDATE_BILLING_ADDRESS_ORDER';

export const updateBillingAddressOrder = (publicId: string, address: Address) =>
    action(UPDATE_BILLING_ADDRESS_ORDER, { publicId, address });
export const requestUpdateBillingAddressOrder = () => action(REQUEST_UPDATE_BILLING_ADDRESS_ORDER);
export const requestUpdateBillingAddressOrderSuccess = (response: any) =>
    action(SUCCESS_UPDATE_BILLING_ADDRESS_ORDER, { response });
export const requestUpdateBillingAddressOrderFailure = (error: any) =>
    action(FAILURE_UPDATE_BILLING_ADDRESS_ORDER, { error });

export const UPDATE_DELIVERY_ADDRESS_ORDER = 'UPDATE_DELIVERY_ADDRESS_ORDER';
export const REQUEST_UPDATE_DELIVERY_ADDRESS_ORDER = 'REQUEST_UPDATE_DELIVERY_ADDRESS_ORDER';
export const SUCCESS_UPDATE_DELIVERY_ADDRESS_ORDER = 'SUCCESS_UPDATE_DELIVERY_ADDRESS_ORDER';
export const FAILURE_UPDATE_DELIVERY_ADDRESS_ORDER = 'FAILURE_UPDATE_DELIVERY_ADDRESS_ORDER';

export const updateDeliveryAddressOrder = (publicId: string, address: Address) =>
    action(UPDATE_DELIVERY_ADDRESS_ORDER, { publicId, address });
export const requestUpdateDeliveryAddressOrder = () => action(REQUEST_UPDATE_DELIVERY_ADDRESS_ORDER);
export const requestUpdateDeliveryAddressOrderSuccess = (response: any) =>
    action(SUCCESS_UPDATE_DELIVERY_ADDRESS_ORDER, { response });
export const requestUpdateDeliveryAddressOrderFailure = (error: any) =>
    action(FAILURE_UPDATE_DELIVERY_ADDRESS_ORDER, { error });

export const UPDATE_ORDER = 'UPDATE_ORDER';
export const REQUEST_UPDATE_ORDER = 'REQUEST_UPDATE_ORDER';
export const SUCCESS_UPDATE_ORDER = 'SUCCESS_UPDATE_ORDER';
export const FAILURE_UPDATE_ORDER = 'FAILURE_UPDATE_ORDER';

export const updateOrder = (publicId: string, order: Order, additionalParams?: AdditionalProductRequestParams) =>
    action(UPDATE_ORDER, { publicId, order, additionalParams });
export const requestUpdateOrder = () => action(REQUEST_UPDATE_ORDER);
export const requestUpdateOrderSuccess = (response: any) => action(SUCCESS_UPDATE_ORDER, { response });
export const requestUpdateOrderFailure = (error: any) => action(FAILURE_UPDATE_ORDER, { error });
